import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'bms-common-footer-buttons',
  templateUrl: './bms-common-footer-buttons.component.html',
  styleUrls: ['./bms-common-footer-buttons.component.scss'],
})
export class BMSCommonFooterButtonsComponent implements OnChanges {
  @Input() primaryTitle: string;
  @Input() isPrimaryEnabled = true;
  @Input() secondaryTitle: string;
  @Input() isSecondaryEnabled = true;
  @Input() optionalTitle: string;
  @Input() isOptionalEnabled = false;
  @Input() isEnableSpinnerLoading = false;
  @Input() isSpinnerLoading = false;

  @Output() onSecondaryClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onOptionalClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onPrimaryClick: EventEmitter<boolean> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isPrimaryEnabled) {
      this.isPrimaryEnabled = changes.isPrimaryEnabled.currentValue;
    }
    if (changes.isSecondaryEnabled) {
      this.isSecondaryEnabled = changes.isSecondaryEnabled.currentValue;
    }
    if (changes.isOptionalEnabled) {
      this.isOptionalEnabled = changes.isOptionalEnabled.currentValue;
    }
  }

  onClickSecondary() {
    this.onSecondaryClick.emit(true);
  }

  onClickPrimary() {
    this.onPrimaryClick.emit(true);
  }

  onClickOptional() {
    this.onOptionalClick.emit(true);
  }
}
